// extracted by mini-css-extract-plugin
module.exports = {"welcome_wrapper":"forum_welcome_welcome_wrapper___tsWG","heading":"forum_welcome_heading__tlfoO","text":"forum_welcome_text__G6aNn"};